import cn from 'classnames';
import { PlateLeaf, type PlateLeafProps } from 'platejs/react';

import styles from './AffiliateLinkElement.module.scss';

export function AffiliateLinkElement(props: PlateLeafProps) {
	return <PlateLeaf {...props} as="span" className={cn(styles.affiliateLink, props.attributes?.className)} />;
}
